const defaults = require('./defaults');

module.exports = {
  ...defaults,
  hot: false,
};
